import t from"@emotion/styled-base";import{baseStyles as e}from"./style";export var ModalContentStyled=t("div",{target:"exp5h810"})(e);
//# sourceMappingURL=ModalContentStyled.js.map